import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Formik,
  Form as FormikForm,
  Field,
  ErrorMessage,
  useFormikContext,
} from "formik";
import Button from "@mui/material/Button";
import { Alert, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { validateELCNoDuplicates, buildELCDuplicateErrors } from "./DynamicFieldRenderer";

export function Form(props) {
  return (
    <Formik
      validateOnMount={false}
      {...props}
    >
      {(formik) => {
        return (
          <FormikForm className="needs-validation">{props.children}</FormikForm>
        );
      }}
    </Formik>
  );
}
export function LABEL(props) {
  const { name, value, label, options, tagName, ...rest } = props;
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <Field
        className="form-control"
        type="text"
        name={name}
        value={value}
        disabled={true}
        id={tagName}
        {...rest}
      />

      <ErrorMessage
        name={name}
        render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
      />
    </>
  );
}
export function LinkLIS(props) {
  const {
    name,
    label,
    options,
    values,
    touched,
    errors,
    dirty,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    handleReset,
    setFieldValue,
    ...rest
  } = props;

  return (
    <>
      <tr>
        <td className="tdheader">
          {label && <label htmlFor={name}>{label}</label>}
        </td>
        <td className="tdclass">
          <Field
            as="select"
            name={props.name}
            value={props.Value}
            onChange={async (e, selected) => {
              const { value } = e.target;
            }}
            className="inputclass"
            id={name}
          >
            {options.map((optn, index) => (
              <option
                key={optn.value}
                value={optn.value}
                label={optn.label || optn.value}
              />
            ))}
          </Field>

          <ErrorMessage
            name={name}
            render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
          />
        </td>
      </tr>
    </>
  );
}

export function SubmitButton(props) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    title,
    status,
    pageSequence,
    childPages,
    schemaPageFields,
    schemaNotFound,
    ...rest
  } = props;
  const {
    values,
    setErrors,
    setTouched,
    submitForm,
    setSubmitting,
    setFieldError,
    setFieldTouched,
  } = useFormikContext();
  const [flag, setFlag] = useState(false);
  const dispatch = useDispatch();
  const [openDupSnackbar, setOpenDupSnackbar] = useState(false);
  const [dupSnackbarMessage, setDupSnackbarMessage] = useState("");

  useEffect(() => {}, [flag]);

  const handleChange = (event) => {
    setSearchParams({ query: event.target.value });
  };

  const closeDupSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setOpenDupSnackbar(false);
  };

  // Build per-table, per-row bullet lines
  const buildDuplicateSummaryLines = (tableName, res) => {
    const lines = [`${tableName}:`];
    res.details.forEach(({ rowIndex, duplicates }) => {
      duplicates.forEach(({ value, columns }) => {
        lines.push(`• Line ${rowIndex + 1}: "${value}" in ${columns.join(", ")}`);
      });
    });
    return lines;
  };

  const handlePreSubmit = async (e) => {
    e.preventDefault();

    const tableNames = Object.keys(values || {}).filter((k) => Array.isArray(values[k]));
    let dupFound = false;
    let aggregatedErrors = {};
    let aggregatedTouched = {};
    let aggregatedLines = [];

    tableNames.forEach((tableName) => {
      const res = validateELCNoDuplicates(values, tableName, schemaPageFields || []);
      if (res.hasDuplicates) {
        dupFound = true;
        const errs = buildELCDuplicateErrors(tableName, res);
        aggregatedErrors = { ...aggregatedErrors, ...errs };

        Object.entries(errs).forEach(([path, msg]) => {
          setFieldError(path, msg);
          setFieldTouched(path, true, false);
          aggregatedTouched[path] = true;
        });

        aggregatedLines = aggregatedLines.concat(buildDuplicateSummaryLines(tableName, res));
      }
    });

    if (dupFound) {
      setErrors(aggregatedErrors);
      setTouched(aggregatedTouched, true);
      setSubmitting(false);
      // Multiline, bulleted message (new lines per row)
      setDupSnackbarMessage(`Duplicate Secondary Sizing selections found:\n${aggregatedLines.join("\n")}`);
      setOpenDupSnackbar(true);
      return; // block submission/navigation
    }

    setOpenDupSnackbar(false);
    await submitForm();
  };

  return (
    <>
    
      <Button
        variant="contained"
        type="button"
        disabled={schemaNotFound || !!props.ediLoading}
        onClick={handlePreSubmit}
         sx={{ textTransform: "none" }}
         size="small"
      >
        {title}
      </Button>
      <Snackbar
        open={openDupSnackbar}
        autoHideDuration={8000}
        onClose={closeDupSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="error"
          sx={{ width: "100%", whiteSpace: "pre-line" }}
          onClose={() => setOpenDupSnackbar(false)}
        >
          {dupSnackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
}
